import type { BonoContent } from '../types/content';
import { BONO_IMAGES, KIT_IMAGES } from './images';

// The 5 bonos included in every version (Base and Kit).
export const bonos: BonoContent[] = [
  {
    number: '01',
    label: 'BONO 01',
    title: 'FICHAS DE PISTA',
    tag: 'FICHA',
    oneLiner: '25 fichas para consultar el objetivo de la sesión antes de entrar a pista.',
    imageLabel: 'Fichas de Pista',
    imageUrl: BONO_IMAGES.bono1
  },
  {
    number: '02',
    label: 'BONO 02',
    title: 'RADAR DEL ALUMNO',
    tag: 'PLANTILLA',
    oneLiner: 'Diagnóstico express en 7 minutos para saber por dónde empezar con cada alumno.',
    imageLabel: 'Radar del Alumno',
    imageUrl: BONO_IMAGES.bono2
  },
  {
    number: '03',
    label: 'BONO 03',
    title: 'SEMÁFORO DE CORRECCIONES RÁPIDAS',
    tag: 'GUÍA RÁPIDA',
    oneLiner: '50 errores comunes para corregir con indicaciones concretas, no discursos largos.',
    imageLabel: 'Semáforo de Correcciones',
    imageUrl: BONO_IMAGES.bono3
  },
  {
    number: '04',
    label: 'BONO 04',
    title: 'PLANIFICADOR 30 DÍAS',
    tag: 'PLANIFICADOR',
    oneLiner: 'Tu hoja de ruta para implantar el sistema poco a poco durante el primer mes.',
    imageLabel: 'Planificador 30 Días',
    imageUrl: BONO_IMAGES.bono4
  },
  {
    number: '05',
    label: 'BONO 05',
    title: 'VUELTA A PISTA',
    tag: 'RECURSO DE PISTA',
    oneLiner: 'Guía orientativa para adaptar el entrenamiento ante molestias o una vuelta progresiva.',
    note: 'Material educativo: no sustituye la valoración de un profesional sanitario.',
    imageLabel: 'Vuelta a Pista',
    imageUrl: BONO_IMAGES.bono5
  }
];

// Extras exclusive to Maestro en Pista + Kit de Ejecución.
export const kitExtras: BonoContent[] = [
  {
    number: '06',
    label: 'EXTRA KIT',
    title: 'EL MAPA DE PISTA',
    tag: 'RECURSO DE PISTA',
    oneLiner: '50 esquemas técnicos para entender un ejercicio o situación de juego de un vistazo.',
    imageLabel: 'Mapa de Pista',
    imageUrl: KIT_IMAGES.mapaDePista,
    premiumOnly: true
  },
  {
    number: '07',
    label: 'EXTRA KIT',
    title: 'PROGRAMADOR 12 MESES',
    tag: 'PLANIFICADOR',
    oneLiner: 'Tu calendario anual para saber qué trabajar cada semana de la temporada.',
    imageLabel: 'Programador 12 Meses',
    imageUrl: KIT_IMAGES.programador12Meses,
    premiumOnly: true
  }
];
